import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateOnboardingProcessStepDto = ClientInferRequest<
  typeof contract.onboardingProcessSteps.update
>["body"];

export type UpdateOnboardingProcessStepResponse = ClientInferResponseBody<
  typeof contract.onboardingProcessSteps.update,
  200
>;

export const updateOnboardingProcessStepApi = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateOnboardingProcessStepDto;
}): Promise<UpdateOnboardingProcessStepResponse> => {
  const response = await api.onboardingProcessSteps.update.mutation({
    params: { id },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update onboarding process step", response.status, response.body);
};
